import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, of, switchMap, tap } from 'rxjs';
import { GenericCommandResult } from '../../pages/enrollment/enrollment';
import { ApiUrlService } from './api-url.service';

interface TokenLogin {
  Username: string;
}

interface Token {
  accessToken: string;
  refreshToken: string;
}

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  baseUrl = this.apiUrlService.getBaseUrl();
  baseUrlIdentityFactoryBridge = 'https://dev.watchdog.willistowerswatson.com/api';

  constructor(private http: HttpClient, private apiUrlService: ApiUrlService) { }

  checkAccess(): Observable<boolean> {
    //localStorage.clear()
    if (localStorage.getItem("X-Login") === "true") {
      return of(true);
    }

    return this.getUser().pipe(
      switchMap((res: any) => {
        const loggedUser = res.toString();
        const token: TokenLogin = { Username: loggedUser };

        return this.http.post<GenericCommandResult>(`${this.baseUrl}/login`, token).pipe(
          tap(res => {
            const token: Token = {
              accessToken: res.data.data.accessToken,
              refreshToken: res.data.data.refreshToken
            };
            localStorage.clear();
            localStorage.setItem("X-Enrollment-Token", token.accessToken);
            localStorage.setItem("X-Enrollment-User", loggedUser);
          }),
          map(() => true),
          catchError(() => of(false))
        );
      }),
      catchError(() => of(false))
    );
  }

  getUser() {
    return this.http.get(`${this.baseUrlIdentityFactoryBridge}/users/me`, {
      withCredentials: true,
      headers: {
        'Access-Control-Allow-Credentials': 'true',
        'Access-Control-Allow-Origin': '*',
        'X-Api-Key': 'iXgORP9Xac7rLw4xkEMdH/xR3eHu/JlyQ0pSQ8MDfYU=',
        'X-App-Name': 'GbpApp'
      }
    });
  }
}
